import React, { Component } from "react";
import { routerActions } from "connected-react-router";
import { arrayOf, bool, func, int, shape, string } from "prop-types";

import { compose } from "redux";
import { connect } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Field, withFormik } from "formik";
import Col from "react-bootstrap/lib/Col";

import { selectors as sessionSelectors } from "reducers/session";
import { actions, selectors } from "reducers/contactDestination";
/*
import { actions as transferActions } from "reducers/transfer";
*/
import * as i18n from "util/i18n";

import TextField from "pages/_components/fields/TextField";
import GeneralMsg from "pages/_components/GeneralMsg";
import { ReactComponent as Show } from "styles/images/search.svg";
import Pagination from "pages/_components/pagination/Pagination";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import ContextMenu from "pages/_components/ContextMenu";
import PageLoading from "pages/_components/PageLoading";
import GridTable from "pages/_components/GridTable/GridTable";
import GridTableContainer from "pages/_components/GridTable/GridTableContainer";
import GridTableData from "pages/_components/GridTable/GridTableData";
import Avatar from "pages/_components/Avatar";
import { debounce } from "lodash";
/*
import FrequentDestinationMobileRow from "./FrequentDestinationMobile";
*/

class TableFrequentDestination extends Component {
    debouncedOnSearch = debounce(() => {
        this.onSearch();
    }, 1500);

    static propTypes = {
        dispatch: func.isRequired,
        values: shape({}),
        listFrequentDestinations: arrayOf(
            shape({
                name: string,
                recipientName: string,
                recipientDocumentType: string,
                recipientDocumentNumber: string,
                cbu: string,
                recipientEmail: string,
            }),
        ),
        fetching: bool,
        moreDestinations: bool,
        isDesktop: bool.isRequired,
        formId: string,
        onRowClick: func.isRequired,
        visibleContextMenu: bool,
        onClickCopy: func,
        frequentDestinationModify: shape({
            idFrequentDestinations: int,
            accountNumber: string,
            productType: string,
            isOwn: string,
            cbu: string,
            recipientDocumentType: string,
            recipientDocumentNumber: string,
            recipientName: string,
            localBank: string,
            SubsidiaryBank: string,
            recipientEmail: string,
            name: string,
        }),
        activeEnvironment: shape({
            permissions: shape({
                transferInternal: bool,
                transferThirdParties: bool,
            }),
        }).isRequired,
    };

    static defaultProps = {
        listFrequentDestinations: [],
        values: {},
        fetching: false,
        moreDestinations: false,
        formId: "",
        visibleContextMenu: false,
        onClickCopy: null,
        frequentDestinationModify: {},
    };

    state = {
        tableHeight: 0,
        currentRow: {},
        goToModify: false,
        pageNumber: 1,
        /* eslint-disable-next-line */
        totalPages: Math.ceil(this.props.listFrequentDestinations.length / 5),
        idFrequentDestinationModify: null,
    };

    componentDidMount() {
        const {
            dispatch,
            values: { filter },
        } = this.props;
        dispatch(actions.loadListRequest(filter));
    }

    componentDidUpdate(prevProps) {
        const { dispatch, frequentDestinationModify, listFrequentDestinations } = this.props;
        const { idFrequentDestinationModify, goToModify } = this.state;

        if (
            frequentDestinationModify &&
            prevProps.frequentDestinationModify !== frequentDestinationModify &&
            goToModify &&
            idFrequentDestinationModify
        ) {
            dispatch(routerActions.push(`/frequentDestination/${idFrequentDestinationModify}/modify/`));
        }

        if (this.props !== prevProps) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                totalPages: Math.ceil(listFrequentDestinations.length / 10),
            });
        }
    }

    componentWillUnmount() {
        this.setState((prevState) => ({ ...prevState, goToModify: false, idFrequentDestinationModify: null }));
    }

    onSearch = () => {
        const { dispatch, values } = this.props;
        dispatch(actions.loadListRequest(values.filter));
    };

    handleCurrentRow = (row) => {
        this.setState((prevState) => ({ ...prevState, currentRow: row }));
    };

    generateTableColumns = () => {
        const { visibleContextMenu } = this.props;

        const onRow = (row) => {
            this.setState((prevState) => ({ ...prevState, currentRow: row }));
        };

        return [
            {
                align: "left",
                key: "reference",
                dataIndex: "reference",
                title: i18n.get("transfer.frequentDestinations.column.reference"),
                width: "15%",
            },
            {
                align: "left",
                key: "headline",
                dataIndex: "headline",
                title: i18n.get("transfer.frequentDestinations.column.headline"),
                width: "20%",
            },
            {
                align: "center",
                key: "document",
                dataIndex: "document",
                title: i18n.get("transfer.frequentDestinations.column.documentType"),
                width: "15%",
            },
            {
                align: "center",
                key: "account",
                dataIndex: "account",
                title: i18n.get("transfer.frequentDestinations.column.acount"),
                width: "20%",
            },
            {
                align: "right",
                key: "email",
                dataIndex: "email",
                title: i18n.get("transfer.frequentDestinations.column.email"),
                width: visibleContextMenu ? "25%" : "30%",
            },
            visibleContextMenu && {
                align: "right",
                key: "contextComponent",
                dataIndex: "contextComponent",
                width: "5%",
                onCell: (record) => ({
                    onClick(e) {
                        e.stopPropagation();
                        onRow(record);
                    },
                }),
            },
        ].filter((c) => !!c);
    };

    renderTableFooter = () => {
        const { moreDestinations } = this.props;
        const { totalPages, pageNumber } = this.state;

        return (
            moreDestinations && (
                <Pagination
                    totalPages={totalPages}
                    pageNumber={pageNumber}
                    action={(num) => this.setState({ pageNumber: num })}
                />
            )
        );
    };

    renderContextMenu = (data) => {
        /*
        const { dispatch, listFrequentDestinations, onClickCopy, isDesktop, activeEnvironment } = this.props;
*/
        const { dispatch, onClickCopy, isDesktop, activeEnvironment } = this.props;

        const { currentRow } = this.state;
        /*
        const transferKind = listFrequentDestinations.isOwn === "1" ? "same" : "other";
*/
        const args = data || currentRow;

        const { reference, headline, document, account, email } = args;
        const i18nParams = {
            reference,
            headline,
            document,
            account,
            email,
        };
        const textCopy = i18n.get("transfer.frequentDestinations.textCopy", null, i18nParams);

        const buttonShare = (
            <Button
                label="frequentDestinations.contextMenu.share"
                className="dropdown__item-btn btn-b-none dropdown__item-btn-custom justify-content-start my-0 ml-0"
                onClick={() => {
                    if (!isDesktop && window.cordova) {
                        const options = {
                            message: textCopy,
                        };
                        window.plugins.socialsharing.shareWithOptions(options, null, null);
                    } else {
                        onClickCopy();
                    }
                }}
            />
        );

        const items = [];
        if (activeEnvironment.permissions.transferThirdParties) {
            items.push({
                label: "frequentDestinations.contextMenu.transfer",
                onClick: () => {
                    /*
                    dispatch(transferActions.loadThirdPartiesTransfer({ cbu: args.account, transferKind }));
*/
                    dispatch(routerActions.push("/transfer/back"));
                },
            });
        }
        if (activeEnvironment.permissions["frequentDestination.manage"]) {
            items.push(
                {
                    label: "frequentDestinations.contextMenu.modify",
                    onClick: () => {
                        this.setState((prevState) => ({
                            ...prevState,
                            goToModify: true,
                            idFrequentDestinationModify: args.idFrequentDestination,
                        }));
                        /*
                        dispatch(actions.modifyFrequentDestinationPreRequest(args.idFrequentDestination));
*/
                    },
                },
                {
                    label: "frequentDestinations.contextMenu.delete",
                    onClick: () => {
                        /*
                        dispatch(actions.deleteFrequentDestinationPreviewRequest(args.idFrequentDestination));
*/
                    },
                },
            );
        }

        return (
            <ContextMenu
                buttonClassName={`align-self-center account-dropdown-header-font ${
                    !isDesktop ? "font-black-alpha" : ""
                }`}
                isDesktop={isDesktop}
                items={items}>
                {isDesktop || !window.cordova ? (
                    <CopyToClipboard text={textCopy}>{buttonShare}</CopyToClipboard>
                ) : (
                    buttonShare
                )}
            </ContextMenu>
        );
    };

    compare = (a, b) => {
        if (a?.recipientName.toLowerCase() < b?.recipientName.toLowerCase()) {
            return -1;
        }
        if (a?.recipientName.toLowerCase() > b?.recipientName.toLowerCase()) {
            return 1;
        }
        return 0;
    };

    populateDestinationData = () => {
        const { listFrequentDestinations, visibleContextMenu } = this.props;
        const { pageNumber } = this.state;

        return (
            listFrequentDestinations &&
            listFrequentDestinations
                .sort(this.compare)
                .map((frequentDestination) => {
                    const {
                        idFrequentDestination,
                        name,
                        recipientName,
                        recipientDocumentType,
                        recipientDocumentNumber,
                        cbu,
                        recipientEmail,
                        isOwn,
                    } = frequentDestination;

                    let result = {
                        idFrequentDestination,
                        key: idFrequentDestination,
                        isOwn,
                    };

                    if (name) {
                        result = { reference: name, ...result };
                    }

                    if (recipientName) {
                        result = { headline: recipientName, ...result };
                    }

                    if ((recipientDocumentType, recipientDocumentNumber)) {
                        const recipientDocument = `${recipientDocumentType} ${recipientDocumentNumber}`;
                        result = { document: recipientDocument, ...result };
                    }
                    if (cbu) {
                        result = { account: cbu, ...result };
                    }
                    if (recipientEmail) {
                        result = { email: recipientEmail, ...result };
                    }
                    if (visibleContextMenu) {
                        result = { contextComponent: this.renderContextMenu(result), ...result };
                    }
                    return {
                        ...frequentDestination,
                        ...result,
                    };
                })
                .slice(10 * (pageNumber - 1), 10 + 10 * (pageNumber - 1))
        );
    };

    revealFunction = () => (
        <Button className="btn-only-icon" bsStyle="link" block={false} onClick={this.onSearch}>
            <Show className="svg-image" />
        </Button>
    );

    renderFilter = (formId) => {
        const field = (
            <Col xs={12}>
                <Field
                    idForm={formId}
                    component={TextField}
                    name="filter"
                    type="text"
                    onKeyDown={this.debouncedOnSearch}
                    inputFunctions={this.revealFunction()}
                    hideLabel
                />
            </Col>
        );

        if (formId === "frequentDestination.modal") {
            return field;
        }

        return (
            <Col sm={12} md={6} lg={4}>
                {field}
            </Col>
        );
    };

    mensajeEmpty = () => {
        const { isDesktop } = this.props;

        return (
            <div className="illustration-wrapper">
                <GeneralMsg
                    idEnviroment
                    imagePath="images/coloredIcons/folder-empty.svg"
                    description={<I18n id="agenda.no.results" />}
                    isDesktop={isDesktop}
                />
            </div>
        );
    };

    render() {
        const { onRowClick, listFrequentDestinations, formId, fetching } = this.props;

        return (
            <PageLoading loading={fetching}>
                <div className="container full-width">
                    <I18n id="echecks.select.contact" component="h2" />
                    {this.renderFilter(formId)}
                    {listFrequentDestinations.length > 0 ? (
                        <>
                            <GridTable className="destinations-list frequent-destination-modal-body">
                                {this.populateDestinationData().map((row) => (
                                    <GridTableContainer
                                        className="card"
                                        key={row.key}
                                        onClick={() => {
                                            onRowClick(row);
                                        }}>
                                        <GridTableData className="headline">
                                            <Avatar
                                                user={{
                                                    userFullName: row?.reference,
                                                    defaultAvatarId: 0,
                                                    email: row?.email,
                                                }}
                                            />
                                            <span className="account-name">{row.reference}</span>
                                        </GridTableData>
                                        <GridTableData className="account-number">
                                            <span className="label">
                                                <I18n id="cbu" defaultValue="CBU/CVU" />
                                            </span>
                                            <span>{row.account}</span>
                                        </GridTableData>
                                    </GridTableContainer>
                                ))}
                            </GridTable>
                            {this.renderTableFooter()}
                        </>
                    ) : (
                        this.mensajeEmpty()
                    )}
                </div>
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    listFrequentDestinations: selectors.getListFrequentDestinations(state),
    /*    moreDestinations: selectors.getMoreDestinations(state),
    frequentDestinationModify: selectors.getFrequentDestinationModify(state), */
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: () => ({
            filter: null,
        }),
    }),
)(TableFrequentDestination);
